import React, { useCallback, useEffect, useState } from "react";
import style from "css/menu.module.css";
import alramstyle from "css/app.module.css";
import "css/menu.css";
import Footer from "components/menu/footer";
import { useNavigate } from "react-router-dom";
import ListItem from "components/menu/listItem";
import { useDispatch, useSelector } from "react-redux";
import { closeAlert, openAlert } from "redux/slices/alertSlice";
import ResPop from "components/menu/resPop";
import ResDetailPop from "components/menu/resDetailPop";
import axios from "axios";
import dayjs from "dayjs";
import { deleteUserInfo } from "redux/slices/userSlice";
import { deleteAllowPageInfo } from "redux/slices/allowPageSlice";
import { Modal, Select } from "antd";
import { Cookies } from "react-cookie";
import Mypagedetailpop from "components/mypagecomponents/mypagedetailpop";
import Alrampop from "components/common/alrampop";
import { useTranslation } from "react-i18next";
import moment from "moment";
/**
 * 파일명: Menu.js
 * 작성자: 권도훈
 * 작성일자: 23.04.06
 * 설명: 메인 메뉴 페이지
 */
function Menu() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { t, i18n } = useTranslation();
  const languageList = [
    { value: "ko-KR", label: t("LANGUAGE.ko") },
    { value: "en-US", label: t("LANGUAGE.en") },
  ];
  const [selectType, setSelectType] = useState(i18n.language);

  const [isOpenRes, setIsOpenRes] = useState(false);
  const [isOpenResDetail, setIsOpenResDetail] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [scheduleList, setScheduleList] = useState([]);
  const [schedule, setSchedule] = useState({});
  const [scheduleType, setScheduleType] = useState("");

  const { confirm } = Modal;

  const logoutHandler = () => {
    confirm({
      className: style.logout_container,
      centered: true,
      title: <p className={style.logout_title}>{t("LABEL.TITLE.LOGOUT")}</p>,
      icon: (
        <img
          src={
            process.env.REACT_APP_CLIENT_URL + "img/common/modal_icon_green.png"
          }
          alt=""
          className={`${style.logout_icon} anticon`}
        />
      ),
      content: (
        <p className={style.logout_content}>{t("MESSAGE.LOGOUT_CONFIRM")}</p>
      ),
      okText: t("common.button.ok"),
      okType: "dashed",
      okButtonProps: {
        className: style.ok_btn,
      },
      cancelText: t("common.button.cancel"),
      cancelButtonProps: {
        className: style.cancel_btn,
        type: "dashed",
      },
      onOk() {
        const authNm = process.env.REACT_APP_AUTH_TOKEN;
        const refreshNm = process.env.REACT_APP_REFRESH_TOKEN;
        const domain = process.env.REACT_APP_DOMAIN;
        const cookies = new Cookies();

        cookies.remove(authNm, { path: "/", domain: domain });
        cookies.remove(refreshNm, { path: "/", domain: domain });
        dispatch(deleteUserInfo());
        dispatch(deleteAllowPageInfo());
        navigate(process.env.REACT_APP_CLIENT_URL);
      },
    });
  };

  const mypageHandler = () => {
    navigate(process.env.REACT_APP_CLIENT_URL + "app/mypage/schedule", {
      state: { type: "card" },
    });
  };

  const meetingHandler = () => {
    navigate(process.env.REACT_APP_CLIENT_URL + "app/meeting/calendar");
  };

  const initSchedule = {
    PROCESS_TYPE: "C",
    TITLE: "",
    CONTENTS: "",
    SCHEDULE_TYPE: scheduleType,
    START_TIME: getReserveDateTime(new Date(), 0),
    END_TIME: getReserveDateTime(new Date(), 30),
    OPEN_YN: "Y",
    RECORD_YN: "N",
    MAIL_YN: "Y",
    MEETING_PW: "",
    PARTICIPANT_LIST: [],
    ENDPOINT_LIST: [],
    ATTACHMENT_LIST: [],
  };
  const openRes = (Res) => {
    setIsOpenRes(true);
    setSchedule(Res);
  };
  const closeRes = () => {
    setIsOpenRes(false);
  };
  // const openResDetail = (Res) => {
  //   let config = {
  //     params: {
  //       SCHEDULE_ID: Res.SCHEDULE_ID,
  //     },
  //   };
  //   axios
  //     .get("/schedule/detail", config)
  //     .then((res) => {
  //       if (res.status === 200) {
  //         setSchedule(res.data.SCHEDULE[0]);
  //         setIsOpenResDetail(true);
  //       }
  //     })
  //     .catch(() => {
  //       const obj = {
  //         title: "알림",
  //         content: "오류가 발생했습니다.",
  //         submitEventHandler: () => {
  //           dispatch(closeAlert());
  //         },
  //       };
  //       dispatch(openAlert(obj));
  //     })
  //     .finally(() => {
  //       setIsLoading(false);
  //     });
  // };
  const closeResDetail = () => {
    setIsOpenResDetail(false);
  };

  const getScheduleList = useCallback(() => {
    const startDate = new Date();
    const endDate = new Date(startDate.getTime() + 7 * 24 * 60 * 60 * 1000); // after a week

    let config = {
      params: {
        ACTIVE_START: moment(startDate).format("YYYY-MM-DD HH:mm:ss"),
        ACTIVE_END: moment(endDate).format("YYYY-MM-DD HH:mm:ss"),
        CALENDAR_TYPE: "MY",
      },
    };

    axios
      .get("/schedule/list", config)
      .then((res) => {
        if (res.status === 200) {
          let date = "";
          let startDate = "";
          let dateList = [];
          let result = [];

          res.data.SCHEDULE.forEach((el) => {
            if (date !== el.START_DATE) {
              if (date !== "") {
                result.push({
                  DATE: startDate,
                  LIST: dateList,
                });
              }
              date = el.START_DATE;
              startDate = el.START_TIME;
              dateList = [];
            }

            dateList.push(el);
          });

          if (dateList.length > 0) {
            result.push({
              DATE: date,
              LIST: dateList,
            });
          }
          setScheduleList(result);
        }
      })
      .catch(() => {
        const obj = {
          title: t("MESSAGE.NOTIFICATION"),
          content: t("MESSAGE.ERROR_OCCURRED"),
          submitEventHandler: () => {
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [dispatch]);

  useEffect(() => {
    if (isLoading) {
      getScheduleList();
    }
  }, [getScheduleList, isLoading]);

  function getReserveDateTime(date, duration) {
    const minutes = date.getMinutes();
    const ceiledMinutes = Math.ceil(minutes / 10) * 10;
    const hours = date.getHours() + Math.floor(ceiledMinutes / 60);
    const ceiledMinutesString = String(ceiledMinutes % 60).padStart(2, "0");
    const ceiledTime = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      hours,
      ceiledMinutesString
    );
    const dateTime = new Date(ceiledTime.getTime() + duration * 60000);

    const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const clientDateString = new Date().toLocaleString("en-US", {
      timeZone: clientTimeZone,
    });
    const clientDate = new Date(clientDateString);
    const offsetInMinutes = clientDate.getTimezoneOffset();
    const TIME_ZONE = offsetInMinutes * 60 * 1000 * -1;

    const formattedDateTime = new Date(dateTime.getTime() + TIME_ZONE)
      .toISOString()
      .replace("T", " ")
      .slice(0, -5);

    return formattedDateTime;
  }

  const getSystemType = useCallback(() => {
    axios
      .get("/schedule/systemInfo")
      .then((res) => {
        if (res.status === 200) {
          setScheduleType(res.data.SYSTEM_TYPE);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    getSystemType();
  }, [getSystemType]);

  const [scheduleid, setscheduleid] = useState("");
  const [opendetail, setopendetail] = useState(false);
  const opendetailpop = (val1, val2) => {
    setscheduleid(val2);
    setopendetail(val1);
  };
  const closeDetailPopup = () => {
    setopendetail(false);
  };

  const payload = useSelector((state) => state.user);
  const [alramopen, setalramopen] = useState(false);
  const alramclose = () => {
    setruncount(true);
    setalramopen(false);
  };
  const closealram = useCallback(() => {
    setruncount(true);
    setalramopen(false);
  }, []);

  useEffect(() => {
    if (alramopen) {
      window.addEventListener("click", closealram);
      return () => {
        window.removeEventListener("click", closealram);
      };
    }
  }, [alramopen, closealram]);

  const [alramdot, setalramdot] = useState(false);
  const [runcount, setruncount] = useState(true);
  const countalram = useCallback(() => {
    let config = {
      params: {
        TARGET_USER: payload.id,
      },
    };
    axios.get("/alram/countalram", config).then((res) => {
      if (res.status === 200) {
        if (res.data > 0) {
          setalramdot(true);
        } else {
          setalramdot(false);
        }
      }
    });
  }, [payload]);
  useEffect(() => {
    if (runcount) {
      countalram();
      if (payload.id !== "") {
        setruncount(false);
      }
    }
  }, [runcount, countalram, payload]);

  return (
    <div className={style.container}>
      <div
        className={style.background_img}
        style={{
          backgroundImage:
            "url('" +
            process.env.REACT_APP_CLIENT_URL +
            "img/menu/background.png')",
        }}
      />
      <section className={style.header}>
        <div className={style.header_logo}>
          <img
            src={process.env.REACT_APP_CLIENT_URL + "img/common/logo_wh.png"}
            alt=""
          />
          <span />
          <p>all Place Hybrid working system</p>
        </div>

        <nav className={style.header_btn}>
          <Select
            // type="short"
            options={languageList}
            value={selectType}
            onChange={(value) => {
              setSelectType(value);
              i18n.changeLanguage(value);
            }}
            // style={{ backgroundColor: 'transparent' }}
          />
          <div>
            <button
              className={`${style.header_alarm_btn} cursor`}
              onClick={(e) => {
                e.stopPropagation();
                alramopen ? alramclose() : setalramopen(true);
              }}
            >
              <img
                src={process.env.REACT_APP_CLIENT_URL + "sample/alarm.png"}
                alt="timeline-alarm"
              />
            </button>
            {alramdot ? (
              <div className={alramstyle.alramdot_main} />
            ) : (
              <div></div>
            )}
            {alramopen ? (
              <div
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <img
                  alt=""
                  src={
                    process.env.REACT_APP_CLIENT_URL + "img/alram/triangle.png"
                  }
                  className={alramstyle.triangle_main}
                />
                <Alrampop alrammoff={() => alramclose()} main={true} />
              </div>
            ) : (
              <div />
            )}
          </div>
          <button
            className={`${style.header_mypage_btn} cursor`}
            onClick={() => mypageHandler()}
          >
            My page
          </button>
          <button
            className={`${style.header_logout_btn} cursor`}
            onClick={() => logoutHandler()}
          >
            Logout
          </button>
        </nav>
      </section>

      <section className={style.body}>
        <ResPop
          isOpenRes={isOpenRes}
          close={closeRes}
          setSchedule={setSchedule}
          schedule={schedule}
          getScheduleList={getScheduleList}
        />
        <ResDetailPop
          isOpenResDetail={isOpenResDetail}
          close={closeResDetail}
          openRes={openRes}
          schedule={schedule}
          getScheduleList={getScheduleList}
        />

        <Mypagedetailpop
          open={opendetail}
          close={closeDetailPopup}
          SCHEDULE_ID={scheduleid}
          refresh={() => {
            getScheduleList();
          }}
          isOpenRes={(res) => {
            openRes(res);
          }}
        />

        <div className={style.content_container}>
          <div className={style.content}>
            <div className={style.menu_list_wrapper}>
              <div className={style.menu_list_container}>
                <ListItem
                  title={{
                    en: "Video Conference Meeting",
                    ko: "회의 시작하기",
                  }}
                  description={t("DESCRIPTION.DESC_1")}
                  type="instant"
                  onClick={() => {
                    openRes(initSchedule);
                  }}
                />
                <ListItem
                  title={{
                    en: "Reservation",
                    ko: "회의 예약",
                  }}
                  description={t("DESCRIPTION.DESC_2")}
                  type="res"
                  onClick={() => meetingHandler()}
                />
                <ListItem
                  title={{
                    en: "Real-Time Meeting",
                    ko: "실시간 회의",
                  }}
                  description={t("DESCRIPTION.DESC_3")}
                  type="myPage"
                  onClick={() =>
                    navigate(process.env.REACT_APP_CLIENT_URL + "app/realtime")
                  }
                />
              </div>
            </div>
          </div>
          <Footer />
        </div>
        <div className={style.timeline_wrapper}>
          <div className={style.timeline_container}>
            <article className={style.timeline_title_container}>
              <p className={style.timeline_title}>Time Line</p>

              <div
                className={`${style.timeline_title_all_btn} cursor`}
                onClick={() => meetingHandler()}
              >
                <span>{t("BTN.VIEW_ALL")}</span>
                <img
                  src={process.env.REACT_APP_CLIENT_URL + "sample/calendar.png"}
                  alt="calendar"
                />
              </div>
            </article>

            {scheduleList.length > 0 &&
              scheduleList.map((el, idx) => (
                <div key={idx}>
                  <div className={style.timeline_date}>
                    <span>
                      {i18n.language === "en-US"
                        ? dayjs(el.DATE).locale("en").format("YY.MM.DD ddd")
                        : dayjs(el.DATE).locale("ko").format("YY.MM.DD ddd")}
                    </span>
                  </div>

                  {el.LIST.map((listEl, listIdx) => (
                    <div className={style.timeline_list} key={listIdx}>
                      <div>
                        {listEl.GAP_TIME + 0 <= 0 ? (
                          <div>
                            <img
                              className={style.timeline_icon}
                              src={
                                process.env.REACT_APP_CLIENT_URL +
                                "img/menu/timeline-active.png"
                              }
                              alt="timeline-active"
                            />
                            <span className={style.starting_date}>
                              {dayjs(listEl.START_TIME).format("HH:mm")} -{" "}
                              {dayjs(listEl.END_TIME).format("HH:mm")}
                            </span>
                            <div className={style.starting_alarm}>
                              {t("MEETING.STATUS.ONGOING")}
                            </div>
                          </div>
                        ) : listEl.GAP_TIME + 0 < 20 &&
                          listEl.GAP_TIME + 0 > 0 ? (
                          <div>
                            <img
                              className={style.timeline_icon}
                              src={
                                process.env.REACT_APP_CLIENT_URL +
                                "img/menu/timeline-inactive.png"
                              }
                              alt="timeline-inactive"
                            />
                            <span className={style.starting_date}>
                              {dayjs(listEl.START_TIME).format("HH:mm")} -{" "}
                              {dayjs(listEl.END_TIME).format("HH:mm")}
                            </span>
                            <div className={style.starting_alarm}>
                              {t("MEETING.STATUS.MIN_BEFORE", {
                                TIME: Math.round(listEl.GAP_TIME),
                              })}
                            </div>
                          </div>
                        ) : (
                          <div>
                            <img
                              className={style.timeline_icon}
                              src={
                                process.env.REACT_APP_CLIENT_URL +
                                "img/menu/timeline-inactive.png"
                              }
                              alt="timeline-inactive"
                            />
                            <span className={style.starting_date}>
                              {dayjs(listEl.START_TIME).format("HH:mm")} -{" "}
                              {dayjs(listEl.END_TIME).format("HH:mm")}
                            </span>
                          </div>
                        )}
                        <span>{listEl.TITLE}</span>
                      </div>

                      <div>
                        <img
                          src={
                            process.env.REACT_APP_CLIENT_URL +
                            "sample/direct.png"
                          }
                          alt="direct"
                          onClick={() => {
                            opendetailpop(true, listEl.SCHEDULE_ID);
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              ))}
          </div>
        </div>
      </section>
    </div>
  );
}
export default Menu;
